import React from "react";
import { styled } from "styled-components";

import { Table } from "affinityUI/data/table";
import { UnitHaemoglobin, UnitNeutrophil, UnitPlatelet, UnitWBC } from "components/views/patientDetails/ui/resultUnits";
import { typeScale } from "lib/themeUtils";
import type { PatientNormalRanges, PatientResultsData } from "types/patient";

import { ResultRow } from "./components/resultRow";

const Unit = styled.div`
  ${typeScale.sm}

  font-weight: normal;
  color: ${(props) => props.theme.colours.bodyLight};

  ${({ theme }) => theme.breakpoints.up("md")} {
    ${typeScale.md}
  }
`;

export const labels = {
  date: "Date",
  time: "Time",
  wbc: "WBC",
  neutrophils: "Neutrophils",
  haemoglobin: "Haemoglobin",
  platelets: "Platelets",
};

export const ResultsTable: React.FC<{
  results?: Maybe<PatientResultsData>;
  neutrophilThreshold?: Maybe<number>;
  patientNormalRanges?: Maybe<PatientNormalRanges>;
}> = ({ results, neutrophilThreshold, patientNormalRanges }) => {
  return (
    <Table sticky>
      <thead data-testid="results-table-header">
        <tr>
          <th scope="col">{labels.date}</th>
          <th scope="col">{labels.time}</th>
          <th scope="col">
            {labels.wbc}
            <Unit>
              <UnitWBC normalRange={patientNormalRanges?.wbcRange} />
            </Unit>
          </th>
          <th scope="col">
            {labels.neutrophils}
            <Unit>
              <UnitNeutrophil normalRange={patientNormalRanges?.neutrophilRange} />
            </Unit>
          </th>
          <th scope="col">
            {labels.haemoglobin}
            <Unit>
              <UnitHaemoglobin normalRange={patientNormalRanges?.haemoglobinRange} />
            </Unit>
          </th>
          <th scope="col">
            {labels.platelets}
            <Unit>
              <UnitPlatelet normalRange={patientNormalRanges?.plateletRange} />
            </Unit>
          </th>
        </tr>
      </thead>
      <tbody>
        {results?.map((result) => (
          <ResultRow key={result.id} result={result} neutrophilThreshold={neutrophilThreshold} />
        ))}
      </tbody>
    </Table>
  );
};
